<div class="guidelines-header" (click)="toggleMinimized()">
  <span class="guidelines-title">{{ title() }}</span>
  <button nbButton ghost size="tiny" (click)="$event.stopPropagation(); toggleMinimized()">
    <nb-icon pack="eva" [icon]="minimized() ? 'chevron-up-outline' : 'chevron-down-outline'"></nb-icon>
  </button>
</div>

@if (!minimized()) {
  <div class="guidelines-body" [nbSpinner]="loading()">
    @if (guidelines(); as dto) {
      @if (dto.infoText) {
        <div class="info-text-section" [innerHTML]="dto.infoText"></div>
      }

      @if (dto.checklistItems.length > 0) {
        <div class="checklist-section">
          <div class="checklist-label">Checkliste</div>
          @for (item of dto.checklistItems; track $index) {
            <nb-checkbox [checked]="isChecked($index)" (checkedChange)="toggleItem($index)">
              {{ item }}
            </nb-checkbox>
          }
        </div>
      }
    }
  </div>
}
